export const selectedStyle = {
  bgColor: 'blackAlpha.80',
} as const;
export const defaultStyle = {} as const;
